import React from "react";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import { withTranslation } from "react-i18next";

import { getTicketsModules } from "./ticketsModules";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`wrapped-tabpanel-${index}`}
      aria-labelledby={`wrapped-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </Typography>
  );
}

function a11yProps(index) {
  return {
    id: `wrapped-tab-${index}`,
    "aria-controls": `wrapped-tabpanel-${index}`
  };
}

const hiddenStyle = {
  maxHeight: "0px",
  overflow: "visible"
};

const shownStyle = {
  paddingBottom: "20px"
};

const Settled = ({ index, t, viewIndex, setViewIndex }) => {
  /*
  let style = shownStyle;
  if (index !== 1) {
    style = hiddenStyle;
  }
  */

  //  const [viewIndex, setViewIndex] = React.useState(0);
  const [modified, setModified] = React.useState(1);

  React.useEffect(() => {
    setModified(v => v + 1);
  }, [index]);

  const handleChange = (event, newValue) => {
    setViewIndex(newValue);
  };

  if (index !== 1) {
    return null;
  }

  const modules = getTicketsModules();

  let category = "settled";
  let tabs = null;
  let tabPanels = null;

  if (modules[category] && modules[category].length) {
    if (modules[category].length > 1) {
      tabs = modules[category].map((module, i) => (
        <Tab key={i} value={i} label={t(module.product)} {...a11yProps(module.product)} />
      ));
      tabs = (
        <Tabs value={viewIndex} onChange={handleChange} centered>
          {tabs}
        </Tabs>
      );
    }

    tabPanels = modules[category].map((module, i) => {
      const ModuleComponent = module.component;
      return (
        <TabPanel key={`m_${i}_${modified}`} value={viewIndex} index={i}>
          <ModuleComponent theme={modules["options"].theme} />
        </TabPanel>
      );
    });
  }

  return (
    <div>
      {tabs}
      {tabPanels}
    </div>
  );
};

export default withTranslation()(Settled);
